import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import BenefitItem from "../generic/BenefitItem";

const BenefitsMost = () => {
  const benefits = [
    "Accurately measure user acquisition effectiveness and reactivation strategies.",
    "Ensure users consistently reach intended destinations within your app, improving activation and retention.",
    "Engage users effectively with platform-specific, targeted messaging without complex setup.",
    "Quickly iterate on messaging and deep linking strategies without relying on developer resources.",
  ];
  const benefitsRed = [
    "Detailed product analytics for tracking button clicks or micro-interactions.",
    "Complex dashboards for in-depth feature usage analysis.",
    "Heavy instrumentation or event tagging across the entire app.",
    "Multi-layered funnels or custom attribution logic.",
  ];
  return (
    <FullPageContainer>
      <Container id={"productInfo"}>
        <TextWrapper>
          <Title>Who Benefits Most from Grovs?</Title>
        </TextWrapper>
        <Content>
          <ItemsWrapper>
            <ItemsTitle>
              Grovs is ideal for product teams who want to:
            </ItemsTitle>
            {benefits.map((item, index) => (
              <BenefitItem key={index} benefit={true} text={item} />
            ))}
          </ItemsWrapper>
          <ItemsWrapper>
            <ItemsTitle>
              Grovs is intentionally focused — ideal for teams who don’t need:
            </ItemsTitle>
            {benefitsRed.map((item, index) => (
              <BenefitItem key={index} benefit={false} text={item} />
            ))}
          </ItemsWrapper>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default BenefitsMost;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: start;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  margin: auto;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;
const ItemsTitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
`;
